var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.isLabelShown
      ? _c("div", { staticClass: "label flex justify-center z-100" }, [
          _c(
            "p",
            {
              staticClass:
                "label__content p-1 px-3 text-sm font-bold rounded-2xl text-white uppercase",
              class: _vm.labelStyles,
            },
            [_vm._v(_vm._s(_vm.labelText))]
          ),
        ])
      : _vm._e(),
    _c("div", { staticClass: "mb-1" }, [
      _c(
        "h2",
        { staticClass: "text-3xl text-center font-bold uppercase leading-10" },
        [_vm._v(" " + _vm._s(_vm._f("capitalize")(_vm.title)) + " ")]
      ),
      _vm.isTrial
        ? _c(
            "p",
            {
              staticClass:
                "text-primary text-center text-xl font-semibold mb-1 uppercase",
            },
            [_vm._v(" 7 day free trial ")]
          )
        : _vm._e(),
    ]),
    _c(
      "h3",
      {
        staticClass: "text-sm text-center font-bold uppercase mb-6",
        class: _vm.sloganStyles,
      },
      [_vm._v(_vm._s(_vm.slogan))]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }